import { Theme, ThemeProvider, Tooltip } from '@mui/material';
import Fab from '@mui/material/Fab';
import { SxProps, styled } from '@mui/material/styles';
import { tooltipTheme } from '../../components/themes/theme';
import { fontFamilies } from '../../utils';
import { fFunction } from './types';
import { useMemo } from 'react';

type ButtonProps = {
    callback?: fFunction;
    text: string;
    disabled?: boolean;
    isSelected: boolean;
    buttonStyles?: SxProps<Theme>;
    selectedStyles?: SxProps<Theme>;
    selectedTooltipText?: string;
    unselectedTooltipText?: string;
    useSpanWrapper?: boolean;
};

export const CustomFab = styled(Fab)(({ theme }) => ({
    fontSize: '14px',
    fontFamilies: fontFamilies.GraphikRegular,
    height: '36px',
    color: '#007BB8',
    backgroundColor: '#fff',
}));

export function ETFCircleButton(props: ButtonProps) {
    const buttonStyles = useMemo(() => {
        return {
            '&:hover': {
                backgroundColor: '#007BB8',
                color: '#ffffff',
            },
            '&:disabled': {
                backgroundColor: '#B1BCC9',
                color: '#ffffff',
            },
            ...props.buttonStyles,
        };
    }, [props.buttonStyles]);

    const fab = (
        <CustomFab
            size='small'
            disabled={props.disabled}
            onClick={props.callback}
            name={props.text}
            sx={
                (props.isSelected
                    ? {
                          backgroundColor: '#007BB8',
                          color: '#ffffff',
                          ...((buttonStyles as SxProps<Theme>) || {}),
                          ...((props.selectedStyles as SxProps<Theme>) || {}),
                      }
                    : buttonStyles || {}) as SxProps<Theme>
            }>
            {props.text}
        </CustomFab>
    );

    return props.disabled || props.selectedTooltipText || props.unselectedTooltipText ? (
        <ThemeProvider theme={tooltipTheme}>
            <Tooltip title={(props.isSelected ? props.selectedTooltipText : props.unselectedTooltipText) || 'No Data'}>
                {props.useSpanWrapper === false ? fab : <span>{fab}</span>}
            </Tooltip>
        </ThemeProvider>
    ) : (
        fab
    );
}
